import { object, string } from '@gogame/schemas';

import {
  NAME,
  EMAIL,
} from 'scenes/Users/PartnerUsers/components/PartnerUserForm/constants';

export const userSchema = object({
  [NAME]: string().required('Full name is required'),
  [EMAIL]: string().required('Email is required'),
});
